// extracted by mini-css-extract-plugin
export default {"root":"AppLayout_root__ewrM-","sidebarWrapper":"AppLayout_sidebarWrapper__n5Dnq","navbarAndContentWrapper":"AppLayout_navbarAndContentWrapper__6SvS6"};